module.exports = __webpack_public_path__ + "media/customizations/paintedprairie/logo-new-504dacb8ce4d002afd0cc1d1103a3596.png";